/**
 * Styles for the UPProvidersTable component
 */

// Common form input styling
export const inputStyle = {
  height: '40px',
  width: '100%',
  padding: '0 10px',
  borderRadius: '8px',
  border: '1px solid #E5E5E5',
  fontFamily: 'greycliff',
  fontSize: '14px',
};

// Pagination link styling
export const paginationLinkStyle = {
  display: 'inline-block',
  margin: '0 3px',
  padding: '4px 8px',
  cursor: 'pointer',
  fontSize: '13px',
  fontFamily: 'greycliff',
  userSelect: 'none',
  color: '#333',
  borderRadius: '3px',
};

// Active pagination link
export const activePaginationLinkStyle = {
  ...paginationLinkStyle,
  backgroundColor: '#ffcf30',
  fontWeight: '600',
};

// Disabled pagination link
export const disabledPaginationLinkStyle = {
  ...paginationLinkStyle,
  cursor: 'default',
  color: '#999',
  opacity: 0.7,
};

// Ellipsis styling
export const ellipsisStyle = {
  display: 'inline-block',
  margin: '0 3px',
  color: '#666',
  fontSize: '13px',
};

// Button styling for action buttons in tables
export const actionButtonStyle = {
  display: 'inline-block',
  padding: '6px 12px',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: '500',
  fontFamily: 'greycliff',
  borderRadius: '4px',
  textAlign: 'center',
  userSelect: 'none',
};

// Primary action button (edit)
export const editButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#f0f8ff',
  color: '#0066cc',
  border: '1px solid #e0e0e0',
};

// Danger action button (delete)
export const deleteButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#fff0f0',
  color: '#cc0000',
  border: '1px solid #ffcccc',
};
